import { rgba } from 'polished';

import colors from '@legacy/moon/particles/colors';

import WrapperLoader from './styles';

const AreaGraphLoader = (): JSX.Element => (
  <WrapperLoader>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 428 110">
      <defs>
        <linearGradient id="areaSkeletonLoader">
          <stop offset="0%" stopColor={`${colors.fullmoon}`} />
          <stop offset="50%" stopColor={`${rgba(colors.titanium, 0)}`} />
          <stop offset="100%" stopColor={`${colors.fullmoon}`} />
          <animateTransform
            attributeName="gradientTransform"
            type="translate"
            from="-1 0"
            to="1 0"
            begin="0s"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </linearGradient>
      </defs>
      <path
        fill="url(#areaSkeletonLoader)"
        d="M428 110V0s-28.5 31.43-62.5 36.83c-34 5.4-36-20.13-84.5-13.75-48.5 6.38-67.5 37.81-111 56.63-43.5 18.83-70-28.15-112-31.38C16 45.11 0 73.6 0 73.6V110h428Z"
      />
    </svg>
  </WrapperLoader>
);

export default AreaGraphLoader;
